// extracted by mini-css-extract-plugin
export default {"dlmText":"data-transfer_dlmText__U8e9E","container":"data-transfer_container__wojWT"};